/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { COOL_GREY, MIDDLE_GREY, WHITE } from '../../styles/colors';
import { MediumText } from '../../styles/styles';


export const InputEffects = css`
  cursor: text;
  
  ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${COOL_GREY};
    opacity: 1; /* Firefox */
  }
`;


export const InputSize = css`
  width: 100%;
  min-height: 40px;
  padding: 8px 14px;
  ${MediumText};
  box-sizing: border-box;
  font-family: Renner,sans-serif !important;
`;


export const InputShape = css`
  border-radius: 4px;
`;


export const InputColors = css`
  border: 1px solid ${MIDDLE_GREY};
  background-color: ${WHITE};
`;


/**
 * A common, styled input (text box)
 */
export const Input = styled('input')`
  ${InputEffects};
  ${InputSize};
  ${InputShape};
  ${InputColors};
`;

